import { render, staticRenderFns } from "./CongridModal.vue?vue&type=template&id=ec5b37ee"
import script from "./CongridModal.vue?vue&type=script&lang=js"
export * from "./CongridModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports